import React from 'react'
import SkipCountryDetection from './SkipCountryDetection'
import IncludeDomains from './IncludeDomains'
import { Divider } from '@material-ui/core'

export default function FilterSettings(props) {
	const { clientId } = props
	return (
		<div className='container'>
			<h1 style={{marginTop: '30px', marginBottom: '20px'}}>Filter Settings</h1>
			<SkipCountryDetection clientId={clientId} />
			<Divider />
			<IncludeDomains clientId={clientId} />
		</div>
	)
}
